import React, { useEffect, useRef } from "react";
import "./OtpInput.css";
import { Input } from "antd";

export default function OtpInput(props) {
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.nativeElement
        .querySelectorAll("input")
        .forEach((input) => input.setAttribute("placeholder", "—"));
    }
  }, []);

  const blurInputs = () => {
    if (inputRef.current) {
      const inputs = inputRef.current.nativeElement.querySelectorAll("input");
      inputs.forEach((input) => {
        input.classList.remove("active-otp-input");
      });
    }
  };

  return (
    <Input.OTP
      dir="ltr"
      onBlur={(e) => {
        blurInputs();
        e.target.classList.add("active-otp-input");
      }}
      onFocus={() => {
        blurInputs();
      }}
      size="large"
      ref={inputRef}
      style={{
        width: "100%",
      }}
      inputMode="numeric"
      autoFocus="autoFocus"
      {...props}
    />
  );
}
